import type { MessageKey } from "./keys";

/** Arabic copy. Key-for-key identical to `en.ts` — enforced by the type annotation. */
export const ar: Record<MessageKey, string> = {
  "eligibility.window_closed": "انتهت مدة الإرجاع لهذا المنتج.",
  "eligibility.sku_excluded": "هذا المنتج غير قابل للإرجاع.",
  "eligibility.already_returned": "تم طلب إرجاع هذا المنتج مسبقًا.",
  "eligibility.not_delivered": "لم يتم تسليم هذا الطلب بعد.",
  "eligibility.eligible": "يمكن إرجاع هذا المنتج.",

  "error.order_not_found": "لم نتمكن من العثور على طلب بهذه البيانات.",
  "error.customer_blocked":
    "خدمة الإرجاع غير متاحة لهذا الحساب. يرجى التواصل مع المتجر.",
  "error.returns_disabled": "المتجر لا يستقبل طلبات الإرجاع حاليًا.",
  "error.policy_violation": "هذا الطلب لا يستوفي سياسة الإرجاع الخاصة بالمتجر.",
  "error.rate_limited": "محاولات كثيرة. يرجى المحاولة بعد بضع دقائق.",
  "error.internal": "حدث خطأ لدينا. يرجى المحاولة مرة أخرى.",
  "error.invalid_code":
    "الرمز مو صحيح أو انتهت مدته. جرّب مرة ثانية أو اطلب رمز جديد.",
  "error.cancel_not_allowed":
    "ما عاد تقدر تلغي هذا الإرجاع، ممكن يكون صار في طريقه للمستودع.",

  "violation.returns_disabled": "المتجر لا يستقبل طلبات الإرجاع حاليًا.",
  "violation.order_not_eligible": "هذا الطلب غير مؤهل للإرجاع.",
  "violation.window_closed": "انتهت مدة الإرجاع لهذا المنتج.",
  "violation.sku_excluded": "هذا المنتج غير قابل للإرجاع.",
  "violation.customer_blocked": "خدمة الإرجاع غير متاحة لهذا الحساب.",
  "violation.reason_not_offered": "المتجر لا يقبل سبب الإرجاع المختار.",
  "violation.photo_required": "يلزم إرفاق صورة للسبب الذي اخترته.",
  "violation.note_required": "اكتب لنا وش صار لما تختار سبب ثاني.",
  "violation.resolution_not_offered": "هذا الخيار غير متاح لدى المتجر.",
  "violation.no_resolution_available":
    "لم يفعّل المتجر أي خيار لمعالجة الإرجاع.",
  "violation.dropoff_not_allowed":
    "التسليم بنفسك غير متاح. الاستلام من العنوان هو الخيار الوحيد.",
  "violation.qty_exceeds_ordered":
    "لا يمكن إرجاع كمية أكبر من الكمية المطلوبة.",
  "violation.line_not_found": "أحد المنتجات المختارة غير موجود في هذا الطلب.",
  "violation.no_lines_selected": "اختر منتجًا واحدًا على الأقل لإرجاعه.",
  "violation.cancel_not_allowed": "لم يعد بالإمكان إلغاء طلب الإرجاع هذا.",

  "reason.size": "المقاس غير مناسب",
  "reason.damaged": "وصل تالفًا",
  "reason.notlike": "لا يطابق الوصف",
  "reason.changed": "تغيّر رأيي",
  "reason.wrong": "تم إرسال منتج خاطئ",
  "reason.spoiled": "وصل تالفًا أو منتهي الصلاحية",
  "reason.other": "سبب ثاني",

  // System-originated. The shopper chose none of these.
  "reason.cod_refused": "رُفض الدفع عند الاستلام، فعاد الطرد",
  "reason.delivery_failed": "تعذّر تسليم الطرد، فعاد إلينا",

  "resolution.refund": "طلب استرداد المبلغ",
  "resolution.exchange": "طلب استبدال",
  "resolution.credit": "طلب رصيد لدى المتجر",

  "collection.pickup": "الاستلام من عنواني",
  "collection.dropoff": "التسليم في نقطة استلام",

  "state.requested": "تم الطلب",
  "state.approved": "قيد المراجعة",
  "state.awaiting_pickup": "قيد المراجعة",
  "state.in_transit": "في الطريق للإرجاع",
  "state.received": "تم الاستلام في المستودع",
  "state.inspected": "تم الفحص",
  "state.booking_failed": "لم يتم حجز الاستلام بعد",
  "state.cancelled": "أُلغي بواسطتك",
  "state.restocked": "أُعيد إلى المخزون",
  "state.quarantined": "محجوز للمراجعة",
  "state.disposed": "تم الإتلاف",
  "state.rejected": "مرفوض",
  "state.lost_in_transit": "فُقد أثناء الشحن",
  "state.expired": "منتهي الصلاحية",
  "state.completed": "مكتمل",

  "state_group.waiting_for_you": "تنتظر ردك",
  "state_group.waiting_for_pickup": "بانتظار المندوب",
  "state_group.with_courier": "مع شركة الشحن",
  "state_group.at_warehouse": "وصلت المستودع",
  "state_group.inspected": "تم فحصها",
  "state_group.refund_due": "دورك ترجّع الفلوس",
  "state_group.closed": "مقفلة",
  "state_group.rejected": "مرفوضة",
  "state_group.cancelled": "ملغية",
  "actor.customer": "أنت",
  "actor.merchant": "المتجر",
  "actor.warehouse": "المستودع",
  "actor.system": "تلقائيًا",
  "actor.carrier": "المندوب",

  "event.created": "قدّمت طلب الإرجاع",
  "event.unknown": "تحديث",

  "grade.sellable": "كالجديد",
  "grade.damaged": "تالف",
  "grade.missing": "مفقود",

  "rejection.merchant_declined": "رفض المتجر طلب الإرجاع.",
  "rejection.policy_refused": "طلب الإرجاع لا يستوفي سياسة المتجر.",
  "rejection.item_not_as_declared":
    "المنتج المستلم لا يطابق ما تم ذكره في الطلب.",
  "rejection.outside_window": "تم إرجاع المنتج بعد انتهاء مدة الإرجاع.",

  "fee.none": "لا توجد رسوم إرجاع",
  "fee.flat": "تُطبّق رسوم إرجاع على هذا الطلب.",
  "fee.percent": "تُطبّق رسوم إرجاع كنسبة من قيمة المنتج.",

  "portal.closed": "المتجر لا يستقبل طلبات الإرجاع حاليًا.",
  "portal.no_resolutions_enabled": "لم يفعّل المتجر أي خيار للإرجاع.",
  "portal.pickup_only":
    "الاستلام من العنوان هو خيار الاستلام الوحيد لدى هذا المتجر.",
  "portal.photo_required_hint": "أرفق صورة ليتمكن المتجر من مراجعة طلبك.",
  "portal.resolution_is_a_request":
    "يُرسل اختيارك إلى المتجر كطلب، والمتجر هو من يقرره وينفّذه.",

  "screen.lookup.title": "ابحث عن طلبك",
  "screen.lookup.phone_description":
    "اكتب رقم الجوال اللي طلبت فيه. بنرسل لك رمز ونعرض لك طلباتك.",
  "screen.lookup.code_title": "اكتب الرمز",
  "screen.lookup.code_description":
    "أرسلنا رمز من ست أرقام على جوالك. الرمز يشتغل عشر دقايق.",
  "screen.lookup.orders_title": "اختر الطلب",
  "screen.lookup.orders_description":
    "هذي طلباتك على هذا الرقم عند المتجر. اختر الطلب اللي تريد ترجّع منه.",
  "screen.lookup.description":
    "أدخل رقم الطلب ورقم الجوال المسجّل عليه. لا حاجة لإنشاء حساب.",
  "screen.items.title": "اختر المنتجات",
  "screen.items.description": "حدّد ما ترغب بإرجاعه والكمية لكل منتج.",
  "screen.reason.title": "سبب الإرجاع",
  "screen.reason.description": "وضّح للمتجر سبب إرجاع كل منتج.",
  "screen.evidence.title": "الصور والملاحظات",
  "screen.evidence.description":
    "إرفاق صورة يساعد المتجر على مراجعة طلبك بشكل أسرع.",
  "screen.resolution.title": "ما الذي ترغب به",
  "screen.resolution.description": "اختر ما تطلبه من المتجر.",
  "screen.review.title": "مراجعة الطلب",
  "screen.review.description": "راجع التفاصيل، ثم اختر طريقة استلام المنتجات.",
  "screen.confirmation.title": "تم إرسال طلب الإرجاع",
  "screen.track.title": "تتبّع طلب الإرجاع",
  "screen.track.description":
    "أدخل رقم طلب الإرجاع ورقم الجوال المسجّل على الطلب.",

  "action.continue": "متابعة",
  "action.back": "رجوع",
  "action.submit": "إرسال الطلب",
  "action.retry": "حاول مرة أخرى",
  "action.track": "تتبّع هذا الإرجاع",
  "action.find_order": "ابحث عن طلبي",
  "action.send_code": "أرسل لي رمز",
  "action.verify_code": "تأكيد",
  "action.resend_code": "أرسل رمز جديد",
  "action.change_phone": "غيّر الرقم",
  "action.have_order_ref": "عندي رقم الطلب",
  "action.use_phone_instead": "ادخل برقم الجوال بدالها",
  "action.skip": "تخطّي هذه الخطوة",
  "action.add_photo": "إضافة صورة",
  "action.remove_photo": "حذف الصورة",
  "action.start_over": "البدء من جديد",
  "action.change": "تعديل",
  "action.cancel_return": "إلغاء طلب الإرجاع",
  "action.cancel_confirm": "نعم، ألغِ طلب الإرجاع",
  "action.keep_return": "الاحتفاظ بطلب الإرجاع",
  "action.refresh_status": "تحديث الحالة",

  "ui.loading": "جارٍ التحميل",
  "ui.offline": "لا يوجد اتصال. بياناتك محفوظة. أعد الاتصال وتابع.",
  "ui.error_generic": "حدث خطأ. يرجى المحاولة مرة أخرى.",
  "ui.empty_generic": "لا يوجد ما يُعرض هنا.",
  "ui.step_of": "الخطوة",
  "ui.step_label.lookup": "البحث",
  "ui.step_label.items": "المنتجات",
  "ui.step_label.reason": "السبب",
  "ui.step_label.evidence": "الصور",
  "ui.step_label.resolution": "الحل",
  "ui.step_label.review": "المراجعة",
  "ui.language_switch": "تغيير اللغة",
  "ui.optional": "اختياري",
  "ui.route_not_found":
    "هذه الصفحة غير موجودة. تأكد من الرابط الذي أرسله المتجر.",
  "ui.server_confirms": "يعتمد المتجر التفاصيل النهائية عند مراجعة طلبك.",

  "field.order_ref.label": "رقم الطلب",
  "field.order_ref.hint":
    "الرقم اللي في رسالة تأكيد الطلب من المتجر، مثل 267115052.",
  "field.order_ref.placeholder": "267115052",
  "field.phone.label": "رقم الجوال",
  "field.phone.hint": "الرقم المستخدم عند إنشاء الطلب.",
  "field.phone.placeholder": "05XXXXXXXX",
  "field.code.label": "رمز التحقق",
  "field.code.hint": "ست أرقام من الرسالة اللي وصلتك الحين.",
  "validation.code_required": "اكتب الرمز اللي وصلك.",
  "shopper.orders.empty":
    "ما لقينا طلبات على هذا الرقم عند هذا المتجر. لو عندك رقم الطلب، اكتبه.",
  "shopper.orders.items": "منتجات",
  "shopper.orders.placed": "تاريخ الطلب",
  "field.reference.label": "رقم طلب الإرجاع",
  "field.reference.placeholder": "RTN-00000",
  "field.sub_reason.label": "تفاصيل إضافية",
  "field.note.label": "ملاحظة للمتجر",
  "field.note.hint": "أي معلومة تود إبلاغ المتجر بها. اختياري.",
  "field.other_note.label": "وش صار؟",
  "field.other_note.hint": "جملة تكفي. المتجر يقراها قبل ما يقرر.",
  "field.quantity.label": "الكمية المراد إرجاعها",

  "validation.order_ref_required": "أدخل رقم الطلب.",
  "validation.phone_required": "أدخل رقم الجوال المسجّل على الطلب.",
  "validation.reference_required": "أدخل رقم طلب الإرجاع.",
  "validation.reason_required": "اختر سببًا لكل منتج.",
  "validation.resolution_required": "اختر ما ترغب به.",
  "validation.collection_required": "اختر طريقة استلام المنتجات.",
  "validation.photo_required": "أرفق صورة لكل منتج يتطلب ذلك.",
  "validation.other_note_required": "اكتب لنا وش صار مع هذا المنتج.",
  "validation.select_at_least_one": "اختر منتجًا واحدًا على الأقل.",

  "items.select_hint": "المنتجات غير القابلة للإرجاع تظهر مع سبب عدم قبولها.",
  "items.none_eligible": "لا يوجد في هذا الطلب منتج يمكن إرجاعه حاليًا.",
  "items.empty": "لا توجد منتجات في هذا الطلب.",

  "reason.select_hint": "هذه هي الأسباب التي يقبلها المتجر.",
  "reason.none_offered": "لم يفعّل المتجر أي سبب للإرجاع.",

  "evidence.required_note":
    "السبب الذي اخترته يتطلب إرفاق صورة، ولا يمكن المتابعة بدونها.",
  "evidence.optional_note":
    "إرفاق الصورة غير مطلوب هنا، ويمكنك إضافتها إن رغبت.",
  "evidence.photos_label": "الصور",
  "evidence.uploading": "جارٍ رفع الصورة",
  "evidence.upload_failed": "تعذّر رفع الصورة. حاول مرة أخرى.",
  "evidence.no_photos": "لم تتم إضافة صور.",

  "resolution.select_hint": "تظهر الخيارات التي يوفّرها هذا المتجر فقط.",
  "resolution.exchange_unavailable":
    "الاستبدال غير متاح لعدم توفر بديل في المخزون.",

  "fee.disclosure_title": "رسوم الإرجاع",
  "fee.deducted_note": "يخصم المتجر هذه الرسوم من قيمة المنتجات المُرجعة.",
  "fee.total_label": "إجمالي رسوم الإرجاع",

  "review.items_heading": "المنتجات",
  "review.reason_heading": "السبب",
  "review.resolution_heading": "ما طلبته",
  "review.collection_heading": "الاستلام",
  "review.collection_hint": "اختر طريقة استلام المنتجات منك.",
  "review.evidence_heading": "الصور والملاحظات",
  "review.photos_attached": "الصور المرفقة",
  "review.fee_heading": "الرسوم",

  "confirmation.heading": "وصل طلبك إلى المتجر",
  "confirmation.reference_label": "رقم طلب الإرجاع",
  "confirmation.what_next":
    "يراجع المتجر طلبك، وسيتم إشعارك عند استلام المنتجات. احتفظ بهذا الرقم لتتبّع الطلب.",

  "track.intro": "تتبّع طلب إرجاع سبق أن أنشأته.",
  "track.reference_label": "رقم طلب الإرجاع",
  "track.copy_reference": "انسخ",
  "track.copy_link": "انسخ الرابط",
  "track.copied": "تم النسخ",
  "track.keep_hint": "احفظ هذا عشان تتابع إرجاعك بعدين. بتحتاج جوالك معه.",
  "track.lines_heading": "المنتجات",
  "track.timeline_heading": "سير الطلب",
  "track.received_note":
    "وصلت منتجاتك إلى سِرداب وتم تسجيلها على طلب الإرجاع هذا.",
  "track.rejection_heading": "سبب رفض هذا المنتج",
  "track.approved_headline": "تمت الموافقة على طلب الإرجاع",
  "track.grade_label": "الحالة عند الفحص",
  "track.qty_expected": "الكمية المعلنة",
  "track.qty_received": "الكمية المستلمة",
  "track.empty_timeline": "لم يتم تسجيل أي إجراء على هذا الطلب حتى الآن.",

  "cancel.confirm_title": "تأكيد إلغاء طلب الإرجاع",
  "cancel.confirm_body":
    "لا يمكن التراجع عن الإلغاء. إذا غيّرت رأيك لاحقًا فستحتاج إلى إنشاء طلب إرجاع جديد، وقد تكون مدة الإرجاع قد انتهت حينها.",
  "cancel.scope_note": "يشمل الإلغاء جميع المنتجات في طلب الإرجاع هذا.",
  "cancel.done": "تم إلغاء طلب الإرجاع. لن يتم استلام أي منتج.",
  "cancel.unavailable_note":
    "لم يعد بالإمكان إلغاء طلب الإرجاع من هنا؛ بعض المنتجات في طريقها إلى المستودع.",
  "cancel.failed_note":
    "تعذّر إرسال طلب الإلغاء. لم يُلغَ طلب الإرجاع، ويمكنك المحاولة مرة أخرى.",
};
